import {
    GESTION_OPERATIVA_ADD_BILLS_BEGIN,
    GESTION_OPERATIVA_ADD_BILLS_DISMISS_ERROR
} from '../constants';


export function addBills( body ) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_ADD_BILLS_BEGIN,
            data: body
        })
    }
}

export function dismissAddBillsError() {
    return {
      type: GESTION_OPERATIVA_ADD_BILLS_DISMISS_ERROR
    }
}

